import { useTheme } from '../contexts/ThemeContext';

interface ThemeToggleProps {
  className?: string;
}

export default function ThemeToggle({ className = '' }: ThemeToggleProps) {
  const { theme, themeSetting, toggleTheme } = useTheme();

  const getLabel = () => {
    if (themeSetting === 'auto') return 'Auto (system)';
    if (themeSetting === 'light') return 'Light mode';
    return 'Dark mode';
  };

  return (
    <button
      onClick={toggleTheme}
      className={`relative inline-flex items-center justify-center p-2 rounded-lg transition-all duration-200 ${
        theme === 'dark' ? 'bg-zinc-700 hover:bg-zinc-600' : 'bg-theme-secondary hover:bg-theme-hover'
      } border border-theme-primary ${className}`}
      aria-label="Toggle theme"
      title={getLabel()}
    >
      {/* Auto icon (system) */}
      <svg
        className={`w-5 h-5 transition-all duration-300 ${
          themeSetting === 'auto' ? 'opacity-100 rotate-0' : 'opacity-0 rotate-90'
        }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        style={{
          position: themeSetting === 'auto' ? 'relative' : 'absolute',
          color: 'var(--text-primary)'
        }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>

      {/* Sun icon (light) */}
      <svg
        className={`w-5 h-5 transition-all duration-300 ${
          themeSetting === 'light' ? 'opacity-100 rotate-0' : 'opacity-0 rotate-90'
        }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        style={{
          position: themeSetting === 'light' ? 'relative' : 'absolute',
          color: 'var(--text-primary)'
        }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
        />
      </svg>

      {/* Moon icon (dark) */}
      <svg
        className={`w-5 h-5 transition-all duration-300 ${
          themeSetting === 'dark' ? 'opacity-100 rotate-0' : 'opacity-0 -rotate-90'
        }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        style={{
          position: themeSetting === 'dark' ? 'relative' : 'absolute',
          color: 'var(--text-primary)'
        }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
        />
      </svg>
    </button>
  );
}
